import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IOrthodonticLkgCfPatientExtensionCreate, IOrthodonticLkgCfPatientExtensionDecision } from "../models/IOrthodonticLkgCfPatientExtension";
import { IOrthodonticLkgCfPatientType } from "../models/IOrthodonticLkgCfPatient";

export class OrthodonticLkgCfPatientExtensionAdministrationApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    createOrthodonticLkgCfPatientExtension(data: IOrthodonticLkgCfPatientExtensionCreate, success: (id: number) => void, error: (message: string) => void, final: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionAdministration/extension`, data, success, error, final);
    }

    getOrthodonticLkgCfPatientTypes(success: (data: IOrthodonticLkgCfPatientType[]) => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionAdministration/orthodonticLkgCfPatientTypes`, success);
    }

    getOrthodonticLkgCfPatientType(patientId: number, success: (data: IOrthodonticLkgCfPatientType) => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionAdministration/orthodonticLkgCfPatientType/${patientId}`, success);
    }

    approveOrthodonticLkgCfPatientExtension(orthodonticLkgCfPatientExtensionId: number, success: () => void, final: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionAdministration/approveOrthodonticLkgCfPatientExtension/${orthodonticLkgCfPatientExtensionId}`, undefined, success, undefined, final);
    }

    rejectOrthodonticLkgCfPatientExtension(data: IOrthodonticLkgCfPatientExtensionDecision, success: () => void, final: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtensionAdministration/rejectOrthodonticLkgCfPatientExtension`, data, success, undefined, final);
    }
}